import { useMutation, useQueryClient } from '@tanstack/react-query';

import { ReviewUnmatchedProductsRequest } from '../../../../types/UnmatchedVesselProductMessage';
import { reviewUnmatchedVesselProducts } from '../../../common/api/clients/vessel.api';
import { queries } from '../../../common/api/queryKeys/queries';

export const useReviewUnmatchedProducts = (vesselId: string) => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (request: ReviewUnmatchedProductsRequest) =>
            reviewUnmatchedVesselProducts({
                vesselId,
                request,
            }),
        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: queries.vessels.detail(vesselId)._ctx.products.queryKey,
            });
            queryClient.invalidateQueries({
                queryKey: queries.vessels.detail(vesselId)._ctx.unmatchedProducts.queryKey,
            });
        },
    });
};
